export const apiConfig = {
    siteUrl: process.env.REACT_APP_SITEURL,
    authority: process.env.REACT_APP_OIDC_AUTHORITY,
    client_id: process.env.REACT_APP_OIDC_CLIENTID,
    redirect_uri: process.env.REACT_APP_OIDC_REDIRECTURI,
    response_type: process.env.REACT_APP_OIDC_RESPONSETYPE,
    scope: process.env.REACT_APP_OIDC_SCOPE,
    loadUserInfo: process.env.REACT_APP_LOAD_USERINFO,
    response_mode: process.env.REACT_APP_RESPONSE_TYPE,
    auth:process.env.REACT_APP_KEYCLOAK_AUTH,
    teamsChatBaseUrl:process.env.REACT_APP_TEAMS_CHAT_BASE_URL,
    studentTransactionsUrl:process.env.REACT_APP_STUDENT_TRANSACTIONS,
    appConfig:JSON.parse(process.env.REACT_APP_APP_CONFIG!),
    outlookMailBaseUrl: process.env.REACT_APP_OUTLOOK_MAIL_BASE_URL,
    outlookCalendarBaseUrl: process.env.REACT_APP_OUTLOOK_CALENDAR_BASE_URL,
    googleCalendarBaseUrl: process.env.REACT_APP_GOOGLE_CALENDAR_BASE_URL,
    studentScholarshipBaseUrl: process.env.REACT_APP_SCHOLARSHIP_BASE_URL,
    graphAuthUrl:process.env.REACT_APP_GRAPH_AUTH_URL,
    freshmanVideoTutorialsUrl : process.env.REACT_APP_FRESHMAN_VIDEO_TUTORIALS,
    campusSafetyAlertUrl : process.env.REACT_APP_CAMPUS_SAFETY_URL,
    onetserviceurl : process.env.REACT_APP_ONET_SUMMARY_URL,
    suite : process.env.REACT_APP_SUITE,
    gmailBaseUrl : process.env.REACT_APP_GMAIL_BASE_URL,
    googleChatUrl : process.env.REACT_APP_GOOGLE_CHAT_URL,
    aiClient: process.env.REACT_APP_AI_CLIENT,
    buduGPTBaseURL: process.env.REACT_APP_BUDU_AGENT_URL
}
